<template>
  <div class="attraction-col col" :class="attractionClasses">
    <div class="attraction">
      <component :is="linkPresent ? 'a' : 'div'" :href="attraction.LinkUrl || ''" class="attraction-title-box" target="_blank">
        <div class="attraction-name">{{ attraction.Name }}</div>
        <div class="attraction-status ttu" :class="attractionClass">{{ attraction.Status }}</div>
        <div class="attraction-hours" :class="attractionClass">{{ attractionHours }}</div>
      </component>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Attraction',
  props: ['attraction', 'index'],
  components: { },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    ...mapGetters(['closedStatuses', 'openStatuses']),
    attractionClasses() {
      let klasses = '';
      if (this.hasClosedStatus) {
        klasses += 'closed-attraction';
      }
      if (this.hasOpenStatus) {
        klasses += 'open-attraction';
      }
      if (this.expanded) {
        klasses += 'expanded';
      }
      return klasses;
    },
    attractionClass() {
      return this.attraction.StatusEnglish;
    },
    linkPresent() {
      return this.attraction.LinkUrl !== '--';
    },
    hasClosedStatus() {
      return this.closedStatuses.indexOf(this.attraction.StatusEnglish) >= 0;
    },
    hasOpenStatus() {
      return this.openStatuses.indexOf(this.attraction.StatusEnglish) >= 0;
    },
    attractionHours() {
      const hours = this.attraction.Hours[this.todaysHours];

      if (hours.Open) {
        if (hours.Open === ' h ') { return ''; }

        return `${hours.Open.replace(' AM', 'am').replace(' PM', 'pm')} - ${hours.Close.replace(' AM', 'am').replace(' PM', 'pm')}`;
      }
      return '';
    },
    todaysHours() {
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const d = new Date();
      return days[d.getDay()];
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  #dashboard {
    .attraction-col {
      background-color: $white;
      margin-bottom: 20px;
      padding-right: 1.5%;
      position: relative;
      width: 100%;
      border-radius: 3px 3px 3px 3px;
      &:before {
        background-color: $open-tab-highlight;
        content: '';
        display: block;
        height: 100%;
        width: 3px;
        position: absolute;
        border-radius: 3px 0 0 3px;
      }
      &.closed-attraction {
        &:before {
          display: none;
        }
      }
      .attraction {
        display: flex;
        flex: 1;
        line-height: 100%;
        padding: 18px 15px 16px;
      }
      .attraction-title-box {
        display: inline-block;
        margin-top: 5px;
        width: 100%;
      }
      .attraction-name {
        color: $dark-gray;
        display: inline-block;
        font-family: $base-font-semibold;
        font-weight: 600;
        font-size: 12px;
        line-height: 1.2;
        letter-spacing: 0.2px;
        margin-right: 10px;
        max-width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        @media (min-width: $tablet) {
          font-size: 22px;
        }
      }
      .attraction-status, .attraction-hours {
        color: $light-gray;
        float: right;
        font-size: 12px;
        font-weight: 300;
        line-height: 1.2;
        letter-spacing: 0.15px;
        margin-top: 5px;
        @media (min-width: $tablet) {
          font-size: 16px;
        }
      }
      &.open-attraction {
        .attraction-status {
          display: none;
        }
        .attraction-hours {
          display: block;
        }
      }
      &.closed-attraction {
        .attraction-title-box {
          opacity: 0.8;
        }
        .attraction-name {
          color: $light-gray;
          font-family: $base-font-regular;
          font-weight: 300;
        }
        .attraction-hours {
          display: none;
        }
      }
      .attraction-hours {
        color: $dark-gray;
      }
    }
  }
</style>
